import { useMutation } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import {
  AdyenPaymentClient,
  AdyenPaymentResultInput,
  AdyenRefundRequest,
  AdyenSessionRequest,
  SubmitStoredPaymentRequest,
} from 'src/WebApiController';

// TODO: Restore feature flag check after testing
// import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
// import { Feature } from 'src/WebApiController';

export function useCreateAdyenPaymentSession() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError, showErrorDialog } = useClientLogContext();
  // TODO: Restore feature flag check after testing
  // const hasAdyenFeature = useUserHasFeature(Feature.AdyenOnlinePayments);

  return useMutation({
    mutationFn: async (request: AdyenSessionRequest) => {
      return await new AdyenPaymentClient(
        activeAccountWebClientConfig
      ).createPaymentSession(request);
    },
    onError: (error: ErrorTypes) => {
      trackError('AdyenPaymentClient.createPaymentSession', error);
      showErrorDialog('AdyenPaymentClient.createPaymentSession', error);
    },
  });
}

export function useSubmitAdyenPaymentResult() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError, showErrorDialog } = useClientLogContext();

  return useMutation({
    mutationFn: async ({
      saleId,
      input,
    }: {
      saleId: number | undefined;
      input: AdyenPaymentResultInput;
    }) => {
      return await new AdyenPaymentClient(
        activeAccountWebClientConfig
      ).submitPaymentResult(saleId, input);
    },
    onError: (error: ErrorTypes, { saleId }) => {
      trackError('AdyenPaymentClient.submitPaymentResult', error, { saleId });
      showErrorDialog('AdyenPaymentClient.submitPaymentResult', error, {
        trackErrorData: { saleId },
      });
    },
  });
}

export function useSubmitPaymentWithStoredMethod() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError, showErrorDialog } = useClientLogContext();

  return useMutation({
    mutationFn: async (request: SubmitStoredPaymentRequest) => {
      return await new AdyenPaymentClient(
        activeAccountWebClientConfig
      ).submitPaymentWithStoredMethod(request);
    },
    onError: (error: ErrorTypes) => {
      trackError('AdyenPaymentClient.submitPaymentWithStoredMethod', error);
      showErrorDialog(
        'AdyenPaymentClient.submitPaymentWithStoredMethod',
        error
      );
    },
  });
}

export function useRefundAdyenPayment() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError, showErrorDialog } = useClientLogContext();

  return useMutation({
    mutationFn: async (request: AdyenRefundRequest) => {
      return await new AdyenPaymentClient(
        activeAccountWebClientConfig
      ).refundPayment(request);
    },
    onError: (error: ErrorTypes) => {
      trackError('AdyenPaymentClient.refundPayment', error);
      showErrorDialog('AdyenPaymentClient.refundPayment', error);
    },
  });
}
